import React from 'react'
import { Link } from 'gatsby'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="alert" title="Windows Software">
        <EuiText>
          <h2>Access your SD Card</h2>
        <ul>
          <li><Link to="/Motion_Detection/SD_Card_Access/Bitkinex/">Bitkinex</Link></li>
          <li><Link to="/Motion_Detection/SD_Card_Access/CuteFTP/">CuteFTP</Link></li>
          <li><Link to="/Motion_Detection/SD_Card_Access/DownThemAll/">DownThemAll! (Firefox Addon)</Link></li>
        </ul>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox